import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { WebhookService } from 'src/app/service/webhook.service';

@Component({
  selector: 'app-webhooks',
  templateUrl: './webhooks.component.html',
  styleUrls: ['./webhooks.component.scss'],
  providers: [MessageService],
})
export class WebhooksComponent {
  receivedName: string = '';
  receivedUrl: string = '';
  webhookCreation: boolean = false;
  processLoading: boolean = false;
  webhooks: any = {};
  webhookData: any = {};
  webhookId: string = '';
  singleWebhook: any;
  isLoading: boolean = false;
  fetchingData: boolean = false;

  constructor(
    private webhookService: WebhookService,
    private router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.getWebhooks();
  }

  tableHeaders: string[] = [
    'Name',
    'Type',
    'Resend',
    'Resend Duration',
    'Acceptable Errors',
  ];
  tableData: any[] = [];

  typeOptions = [
    { value: 'Sending', label: 'Sending' },
    { value: 'Receiving', label: 'Receiving' },
  ];

  selectedType: string = '';

  onSelectedType(selectedValue: string) {
    this.selectedType = selectedValue;
    // console.log('Selected Dropdown Value:', selectedValue);
  }

  resendOptions = [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
  ];

  selectedResend: string = '';

  onSelectedResend(selectedValue: string) {
    this.selectedResend = selectedValue;
    // console.log('Selected Dropdown Value:', selectedValue);
  }

  timeOptions = [
    { value: '1', label: '1 second' },
    { value: '2', label: '2 second' },
    { value: '3', label: '3 second' },
    { value: '4', label: '4 second' },
    { value: '5', label: '5 second' },
  ];

  selectedTime: string = '';

  onSelectedTime(selectedValue: string) {
    this.selectedTime = selectedValue;
    // console.log('Selected Dropdown Value:', selectedValue);
  }

  errors: string[] = [''];

  newErrors(data: string) {
    this.errors = data.split(',');
    this.errors = this.errors.map((ip: string) => {
      return ip.trim();
    });
  }

  name(data: string) {
    this.receivedName = data;
  }
  webhookUrl(data: string) {
    this.receivedUrl = data;
  }

  error: string = '';
  newResend: boolean = false;

  modalTitle = 'Add Webhook Configuration';
  modalTitle2 = 'Update Webhook Configuration';
  isModalOpen = false;
  isModalOpen2 = false;
  duration: string = '';

  addWebhookModal = () => {
    this.isModalOpen = true;
  };

  formModal = {
    webhookConfigId: '',
    name: '',
    type: '',
    webhookUrl: '',
    resend: '',
    resendDuration: 0,
    acceptableError: [] as string[],
    senderUrl: '',
  };

  closeModal = () => {
    this.isModalOpen = false;
  };
  closeModal2 = () => {
    this.isModalOpen2 = false;
  };

  createWebhook = () => {
    this.isLoading = true;
    if (this.selectedResend == 'true') {
      this.newResend === true;
    } else {
      this.newResend === false;
    }
    const newDuration = parseInt(this.selectedTime, 10);
    const newWebhook = {
      name: this.receivedName,
      type: this.selectedType,
      webhookUrl: this.receivedUrl,
      resend: this.newResend,
      resendDuration: newDuration,
      acceptableError: this.errors,
    };
    this.webhookService.createWebhook(newWebhook).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.messageService.add({
          severity: 'success',
          summary: 'Successful',
          detail: 'Webhook Configuration Created Successfully',
        });

        // console.log('Webhook Config Added Successfully');
        this.isLoading = false;
        this.isModalOpen = false;
        this.getWebhooks();
        setTimeout(() => {
          this.isLoading = false;
        }, 2000);
      } else {
        this.isLoading = false;
        // console.log('Problem creating Webhook Configuration');
      }
    });
  };

  updateWebhook = (id: string | number) => {
    this.isModalOpen2 = true;
    this.singleWebhook = this.webhooks.find(
      (obj: { _id: string | number }) => obj._id === id
    );
    this.formModal.webhookConfigId = this.singleWebhook._id;
    this.formModal.senderUrl = this.singleWebhook.senderUrl;
    this.formModal.name = this.singleWebhook.name;
    this.formModal.type = this.singleWebhook.type;
    this.formModal.webhookUrl = this.singleWebhook.webhookUrl;
    this.formModal.resend = this.singleWebhook.resend;
    this.formModal.resendDuration = this.singleWebhook.resendDuration;
    this.formModal.acceptableError = this.singleWebhook.acceptableError;
  };

  onUpdatedName(data: string) {
    this.formModal.name = data;
  }

  onUpdatedType(data: string) {
    this.formModal.type = data;
  }

  onUpdatedUrl(data: string) {
    this.formModal.webhookUrl = data;
  }

  onUpdatedResend(data: string) {
    this.formModal.resend = data;
  }

  onUpdatedResendDuration(data: string) {
    this.duration = data;
  }

  onUpdatedErrors(data: string[]) {
    this.formModal.acceptableError = data;
  }

  patchWebhook = () => {
    // console.log(this.formModal);
    this.formModal.resendDuration = parseInt(this.duration, 10);
    this.webhookService.updateWebhook(this.formModal).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.messageService.add({
          severity: 'success',
          summary: 'Updated Successfully',
          detail: 'Configuration Updated Successfully',
        });
        this.isLoading = true;
        // console.log('Webhook Config Updated Successfully');
        this.isModalOpen2 = false;
        setTimeout(() => {
          this.isLoading = false;
        }, 2000);
      } else {
        this.isLoading = false;
        // console.log('Problem updating Webhook Configuration');
      }
    });
  };

  async getWebhooks() {
    this.fetchingData = true;

    this.webhookService.getWebhooks().subscribe({
      next: (res: any) => {
        this.webhooks = res.data;
        if (this.webhooks.length > 0) {
          for (let i = 0; i < this.webhooks.length; i++) {
            // console.log(this.webhooks[i]);
          }
          this.tableData = this.webhooks?.map((i: any, n: number) => {
            return [
              i._id,
              i.name,
              i.type,
              i.resend,
              i.resendDuration,
              i.acceptableError,
            ];
          });
        }
        this.fetchingData = false;
      },
      error: (error: any) => {
        this.isLoading = false;
      },
    });
  }

  showSingleWebhook = (id: string | number) => {
    this.singleWebhook = this.webhooks.find(
      (obj: { _id: string | number }) => obj._id === id
    );
    this.router.navigate([`webhooks/${id}`]);
  };
}
